/**
 * Official-style WhatsApp logo SVG (inline, no extra dep).
 * Use the `className` prop for sizing/colour. `fill` follows currentColor.
 */
export const WhatsAppIcon = ({ className = "w-5 h-5", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    aria-hidden="true"
    className={className}
    {...rest}
  >
    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.876 2.722.876.345 0 2.32-.42 2.32-1.405 0-.387-.187-.832-.36-1.207-.42-.93-.79-1.39-.946-1.39M16.282 27.71c-1.32 0-2.59-.276-3.808-.732l-.49-.196-5.5 1.42 1.42-5.5-.196-.49a10.42 10.42 0 0 1-.732-3.808c0-5.184 4.218-9.402 9.402-9.402 5.184 0 9.402 4.218 9.402 9.402 0 5.184-4.218 9.402-9.402 9.402m0-20.804C9.967 6.906 4.78 12.092 4.78 18.407c0 2.027.535 4.018 1.548 5.77L4.78 30l5.97-1.522a11.61 11.61 0 0 0 5.53 1.41h.005c6.314 0 11.5-5.186 11.502-11.502 0-3.072-1.196-5.96-3.372-8.136a11.43 11.43 0 0 0-8.135-3.371" />
  </svg>
);

export default WhatsAppIcon;
